/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Action_No_ParametersInputs */



/**
* | output |
* | --- |
* | "This action takes no parameters." |
*
* @param {Integrations_Action_No_ParametersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_action_no_parameters = /** @type {((inputs?: Integrations_Action_No_ParametersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Action_No_ParametersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Aktion benötigt keine Parameter.")
	return /** @type {LocalizedString} */ ("This action takes no parameters.")
});